<template>
  <div
    v-tooltip="{
      content: t('dsr_chat_participants_tooltip'),
      distance: 8,
      placement: Placement.TopStart,
      delay: { show: 300, hide: 100 },
    }"
    class="avatar-area"
    @click="$emit('show-conversation-participants-modal')"
  >
    <FriedH4 class="participants-number">{{ participantsCount }}</FriedH4>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { Placement } from '@getaccept/fried-tofu';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { ChatParticipant, Conversation } from '../types';
import { ConversationType } from '../types';
import type { Participant } from '../../types';

export default defineComponent({
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: () => ({}),
    },
    participants: {
      type: Array as PropType<ChatParticipant[]>,
      default: () => [],
    },
    allParticipants: {
      type: Array as PropType<Array<Participant>>,
      default: () => [],
    },
  },
  emits: ['show-conversation-participants-modal'],
  setup(props) {
    const isGeneralChat = computed(() => props.conversation.type === ConversationType.General);

    const participantsCount = computed(() =>
      isGeneralChat.value
        ? props.allParticipants.length
        : props.conversation?.participants?.length || props.conversation?.participantIds?.length
    );

    return {
      isGeneralChat,
      participantsCount,
      Placement,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '../scss/chat-list-item';
</style>
